export default __webpack_public_path__ + "static/media/5.35e2b3d3.jpg";